import React from 'react';
import Input from '@components/Webform/WebformContent/Inputs/Input';
import Select from '@components/Webform/WebformContent/Inputs/Select';
import Textarea from '@components/Webform/WebformContent/Inputs/Textarea';
import type {
  IFormContentProps,
  IInputAttributes,
} from '@components/Webform/WebformContent/interfaces';

const FormContent: React.FC<IFormContentProps> = ({
  item,
  handleChange,
  lang,
}): any => {
  if (!item) {
    console.error('there was an error while getting the data');
  }

  if (item.markup) {
    return <div dangerouslySetInnerHTML={{ __html: item.markup }} />;
  }

  const inputAttributes: IInputAttributes = {
    className: `form-${item.type}`,
    id: `edit-${item.id}`,
    lang,
    maxLength: item.type === 'email' ? 255 : undefined,
    name: `${item.id}`,
    onChange: handleChange,
    options: item.options,
    required: item.title ? item.title.includes('*') : false,
    title: item.title,
    type: item.type === 'textfield' ? 'text' : `${item.type}`,
    value: item.type === 'checkbox' ? '1' : undefined,
  };

  switch (item.type) {
    case 'select':
    case 'webform_term_select':
    case 'webform_entity_select':
      return <Select inputAttributes={inputAttributes} />;
    case 'webform_actions':
      return <Input inputAttributes={inputAttributes} />;
    case 'textarea':
      return <Textarea inputAttributes={inputAttributes} />;
    default:
      return <Input inputAttributes={inputAttributes} />;
  }
};

export default FormContent;
